@if (combinedTogglesObservables$ | async; as combinedToggles) {
  <!-- Stocks slider -->
  @if (hasStockTerms()) {
    <stock-toggle
      [slider]="combinedToggles.stockTermsToggle"
      (valueUpdate)="sliderChange()"
      [showWarning]="showTradingHoursWarning()"
      [warnings]="getStockWarningMessage()"
      [actionType]="getWarningAction()"
      [tradable]="getStockToggleTradable()">
    </stock-toggle>
  }
  <!-- Crypto Terms slider -->
  @if (showRegularTerms()) {
    <bp-switch
      [model]="combinedToggles.swapLock"
      field="enabled"
      [mb]="20"
      (valueChange)="sliderChange()">
    </bp-switch>
  }
  <!-- Hold coin slider -->
  @if (buyingHoldTradable()) {
    <bp-switch
      [model]="combinedToggles.swapLock"
      field="hold_coin_terms"
      [mb]="20"
      (valueChange)="sliderChange()"
      >
      <div left class="text-small-black">
        {{ getHoldInfo() | translate }}
        <a [href]="getHodlLink()" [target]="'_blank'" [bp-tooltip]="'tradeonly_summary_tooltip' | translate">
          <span class="bpi__icon-info text-blue"></span>
        </a>
      </div>
    </bp-switch>
  }
  <!-- Index terms slider -->
  @if (hasIndexSlider()) {
    <div>
      <bp-switch [model]="combinedToggles.swapLock" field="index_terms" [mb]="20">
        <div left class="text-small-black">
          {{ "index_rebalance_terms_description" | translate: [getIndexName()] }}
          <a [href]="getIndexTermsLink()" [target]="'_blank'">{{ "index_prospectus" | translate }}</a>
        </div>
      </bp-switch>
    </div>
  }
  <!-- User is stocks not appropriate slider  -->
  @if (showStockRiskToggle()) {
    <div>
      <bp-switch [model]="combinedToggles.swapLock" field="stock_risk" [mb]="20">
        <div left>
          <div class="font-size-13 large-weight pb-10">
            {{ "stocks_toggle_not_appropriate_title" | translate }}
          </div>
          <div class="font-size-11 info-color">
            {{ "stocks_toggle_not_appropriate_description" | translate }}
          </div>
        </div>
      </bp-switch>
    </div>
  }
  <!-- User get warning from to Appr test state  -->
  <!-- Swaps into BEST 2.0 -->
  @if (showBest2Terms()) {
    <div>
      @if (showBest2Terms()) {
        <bp-switch [model]="combinedToggles.swapLock" field="best2_terms" [mb]="20">
          <div left>
            <div class="text-small-black">
              {{ "read_and_agree_to" | translate }}
              <a [href]="getBest2TermsLink()" [target]="'_blank'">{{
                "best2_terms_and_conditions" | translate
              }}</a>
            </div>
          </div>
        </bp-switch>
      }
    </div>
  }
}
